// src/components/Header.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="bg-white text-black p-4 flex justify-between items-center relative">
      <div className="flex items-center justify-center w-full md:w-auto">
        <Link to="/">
          <img
            src="/assets/logo.png"
            alt="Rubix Consultants Logo"
            className="h-10 w-auto md:h-20 md:w-auto"
          />
        </Link>
      </div>
      <nav className="hidden md:flex md:mr-4">
        <ul className="flex space-x-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          <li><Link className="hover:text-gray-500" to="/">HOME</Link></li>
          <li><Link className="hover:text-gray-500" to="/about">ABOUT</Link></li>
          <li><Link className="hover:text-gray-500" to="/work">WORK</Link></li>
        </ul>
      </nav>
      <button className="md:hidden" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end">
          <div className="bg-white w-64 h-full shadow-xl flex flex-col items-center">
            <button className="self-end p-4" onClick={toggleMobileMenu}>
              <FaTimes size={24} />
            </button>
            <nav className="mt-8">
              <ul className="flex flex-col space-y-4 text-xl" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                <li><Link className="hover:text-gray-500" to="/" onClick={toggleMobileMenu}>HOME</Link></li>
                <li><Link className="hover:text-gray-500" to="/about" onClick={toggleMobileMenu}>ABOUT</Link></li>
                <li><Link className="hover:text-gray-500" to="/work" onClick={toggleMobileMenu}>WORK</Link></li>
              </ul>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
